export default "/JMMMU/japanese_art.f95068a5-901068.jpg";